import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSuzukiComponent } from './simple-icons-suzuki.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSuzukiComponent ],
    exports:      [ SimpleIconsSuzukiComponent ],
    bootstrap:    []
})
export class SimpleIconsSuzukiModule {}
